export default __webpack_public_path__ + "static/media/type_1.30bc2d73.svg";